import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './App.less'
import reportWebVitals from './reportWebVitals'
import RoutesWithBrowser from './routes'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<RoutesWithBrowser />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
